import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

export default ({ circle }) => (
	<Grid data-testid="sponsored-circles-member-cell" container>
		<Grid item>
			<Typography style={{ fontSize: '17px', lineHeight: '22px', letterSpacing: '0.51', color: '#011020' }}>
				{circle ? circle.unusedMembers : 0}
			</Typography>
		</Grid>
	</Grid>
)
